import styled from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

import { zIndex } from '@styles/zIndex'

export const Root = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: ${mainColors.white};
  border-top: 1px solid ${mainColors.neutralMedium};
  overflow: hidden;
  white-space: nowrap;
  z-index: ${zIndex.MOBILE_MENU_RIBBON};

  &:after {
    content: '';
    position: absolute;
    top: -20px;
    bottom: -20px;
    right: 0;
    left: 0;
    box-shadow: inset ${mainColors.white} 0 0 15px 15px;
    pointer-events: none;
  }
`

export const MenuItemsContainer = styled.div`
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  padding: 0 10px;
`

export const MenuItem = styled.div`
  display: inline-block;
  padding: 14px;
  color: ${mainColors.neutralExtraDark};

  &.active {
    color: ${mainColors.primaryDark};
    font-weight: 500;
  }
`

export const RibbonPlaceholder = styled.div`
  width: 100%;
  height: 50px;
  position: relative;
`
